module.exports = __webpack_public_path__ + "static/media/beauty-and-style.9b379293.svg";